module.exports = __webpack_public_path__ + "static/img/47-1.e5822d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/47-1.jpg
// module id = nx6S
// module chunks = 0